function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  d: "M3.667 3.278V2.056a1.5 1.5 0 011.5-1.5h1.666a1.5 1.5 0 011.5 1.5v4.722h1.611a1.5 1.5 0 011.5 1.5v2.166a1 1 0 01-1 1h-.333V9.611a.5.5 0 10-1 0v1.833h-1.58c.016-.071.025-.145.025-.222v-1.11a1 1 0 00-1-1H5.444a1 1 0 00-1 1v1.11c0 .077.009.151.025.222H1.556a1 1 0 01-1-1V5.451a1 1 0 01.552-.894l2.559-1.28zm1.166 3.5a.389.389 0 100 .778.389.389 0 000-.778zm0-1.556a.389.389 0 100 .778.389.389 0 000-.778zm0-1.555a.389.389 0 100 .777.389.389 0 000-.777zm0-1.556a.389.389 0 100 .778.389.389 0 000-.778zm2.334 0a.389.389 0 100 .778.389.389 0 000-.778zm0 4.667a.389.389 0 100 .778.389.389 0 000-.778zm0-1.556a.389.389 0 100 .778.389.389 0 000-.778zm0-1.555a.389.389 0 100 .777.389.389 0 000-.777zM9.5 7.556a.389.389 0 100 .777h.222a.389.389 0 100-.777H9.5zm-7 .777a.389.389 0 000 .778h.222a.389.389 0 100-.778H2.5zm0-1.555a.389.389 0 100 .778h.222a.389.389 0 000-.778H2.5zm0-1.556A.389.389 0 002.5 6h.222a.389.389 0 000-.778H2.5z"
});

var SvgCompanies = function SvgCompanies(props) {
  return React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12"
  }, props), _ref);
};

export default SvgCompanies;